import { STORE_TRACK_PREFIX } from '../track-params';
/**
 * Performs the tracking calls to UDL (Universal Data Layer).
 * @module UDLAPI
 * @class
 * @internal
 */
class UDLAPI {
    constructor(options = {}) {
        this.options = options;
        this.name = "UDL tag";
        this.optOut = false;
        this.initialTrack = true;
    }

    /**
     *
     * @method pageView
     * @param {String} eventName
     * @param {Object} params
     * @returns {Promise}
     * @internal
     */

    pageView(...args) {
        return this.track(...args);
    }

    /**
     *
     * @method track
     * @param {String} eventName
     * @param {Object} params
     * @returns {Promise}
     * @internal
     */

    track(eventName, params) {
        window.dataLayer = window.dataLayer || [];
        window.beaconCustomTrack = window.beaconCustomTrack || {};
        
        const isPageview = params && params.event === "e_pageView";

        /* data-metrics prefix by default lower-case params object keys' name, will revisit if analytic code is case-sensitve. */
        let _params = {};
        
        // switch statement to transform data into the accepeted format.
        switch(eventName){
            case 'linkClick': {
                _params = { event: params.event, linkPlacement: params.linkPlacement || STORE_TRACK_PREFIX, linkID: params.linkId };
                break;
            }
            case 'searchSortBy': {
                _params = {event: params.event, searchSortType: params.searchsorttype}
                break;
            }

            default: {
                _params = params;
                break;
            }
        }

        window.dataLayer.push(_params);

        
        // send optimizely events after dataLayer push (GA/Adobe)
        if(isPageview){
            // capture adobe timestamp asap to get closer mesure to adobe firing time
            const perfstamp = performance && performance.now && typeof performance.now === "function" ? performance.now() : null; 
            
            window.beaconCustomTrack.adobeFired = true;
            window.beaconCustomTrack.sendLogglyBeacon && window.beaconCustomTrack.sendLogglyBeacon({perfstamp});

            if(this.initialTrack){
                window["optimizely"] = window["optimizely"] || [];
                window["optimizely"].push({
                    "type": "sendEvents"
                });

                this.initialTrack = false;  
            }
        }
    }

}

export default UDLAPI;
